exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#handoverMap[data-v-ea890e1c] {\n  width: 100%;\n}\n@media (min-width: 992px) {\n#handoverMap[data-v-ea890e1c] {\n    height: 300px;\n}\n}\n@media (max-width: 991px) {\n#handoverMap[data-v-ea890e1c] {\n    height: 200px;\n}\n}\ni.fal[data-v-ea890e1c] {\n  color: #0b97c4;\n}", ""]);

// exports
